"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 业务系统配置模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/query/' + id,
      method: 'post'
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/save',
      method: 'post',
      data: data
    });
  },
  deleteItem: function deleteItem(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/delete/' + id,
      method: 'post'
    });
  },
  enableItem: function enableItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/update/status',
      method: 'post',
      data: data
    });
  },
  disabledItem: function disabledItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/update/status',
      method: 'post',
      data: data
    });
  },
  roleInfoSave: function roleInfoSave(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/accountInfo/assign/role',
      method: 'post',
      data: data
    });
  },
  exportReportFile: function exportReportFile(url, data) {
    return (0, _request.default)({
      module: 'CORE',
      url: url,
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};